import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import pic1 from './../../img/tutorial/STEM_orders1@3x.png';
import pic2 from './../../img/tutorial/STEM_orders2@3x.png';

class TutorialStep8 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step8)}>
        <div className={classnames(grid.row, baseStyles.mb_30)}>
          <div className={classnames(grid.col_6)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li><span className={baseStyles.block}>All answers should be typed, <strong className={baseStyles.danger_title}>no pictures</strong></span><strong className={baseStyles.danger_title}>of handwriting are acceptable;</strong></li>
              <li>The final paper should be uploaded in the required file format;</li>
            </ul>
          </div>
          <div className={classnames(grid.col_6)}>
              <img className={baseStyles.pic1} src={pic2} alt="All answers should be typed" width="251px" />
          </div>
        </div>

        <div className={classnames(grid.row, baseStyles.mb_30, baseStyles.reverse)}>
          <div className={classnames(grid.col_6)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li className={baseStyles.mla}>Analytical skills & technical background is a must;</li>
              <li className={baseStyles.apa}><strong>The price for STEM subjects is usually higher.</strong></li>
            </ul>
          </div>
          <div className={classnames(grid.col_6)}>
            <img className={baseStyles.pic2} src={pic1} alt="Analytical skills" width="251px" />
          </div>
        </div>

      </div>
    )
  }
}

export default TutorialStep8;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep8.js